import React, {Component} from 'react'
import {Icon} from 'semantic-ui-react'
import Utils from '../../modules/utils'

class ActiveCadsCard extends Component
{
  constructor(props)
  {
    super(props)
    this.state = {activeCads: 0}
  }

  componentDidMount() {
    Utils.get('active_cads', (err, res) => {
      if (err) {
        alert('There was an error when trying to get number of active cads')
      } else {
        this.setState({activeCads: res.data})
      }
    })
  }

  render() {
    let {activeCads} = this.state

    return (
      <div style={{background: 'white', width: '250px', padding:'30px 20px', borderRadius: '10px', boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.2)'}}>
        <Icon name="object group outline" style={{fontSize: '50px'}}/><br/>
        <h3 style={{marginTop: '5px'}}>Active Cads</h3>
        <h1 style={{marginTop: '20px'}}>{activeCads}</h1>
      </div>
    )
  }
}

export default ActiveCadsCard
